import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ConstantService } from '../../constant/constant.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PartnerService {

  constructor(
      public constantService: ConstantService,
      public http: HttpClient
  ) { }

  get(param: Array<object>) {
      if (!param.length) return this.http.get(this.constantService.getUrl(this.constantService.PARTNERS));
      else return this.http.get(this.constantService.getUrlByQuery(this.constantService.PARTNERS, param));
  }

  courseList() {
    return this.http.post(this.constantService.getUrl(`${this.constantService.PARTNERS}/activecourse`),{});
  }

  downloadMISExcelReport(params?: any): Observable<HttpResponse<Blob>> {
    return this.http.get(this.constantService.getUrl(this.constantService.PARTNERS + '/misreport/download/excel'), {
      params: params,
      observe: 'response',
      responseType: 'blob'
    });
  }
}
